/**
 * Created by ivan on 02.02.18.
 */

const CrabMakerCellView = BaseCellView.extend({
    ctor: function (crabMakerCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        const image = new cc.Sprite(this.getImage(crabMakerCell.stage));
        image.setAnchorPoint(0.5, 0.5);
        image.setAlignment(this.width / 2, this.height / 2);
        this.addChild(image);
        this.image = image;

        this.addAnimation();

        this.initialize(crabMakerCell);
    },

    initialize: function (crabMakerCell) {
        this._super(crabMakerCell);

        crabMakerCell.onChangeStage = this.createListener(this.changeStage.bind(this));
    },

    unuse: function () {
        this.cell.onChangeStage = function () {};

        this._super();
    },

    addAnimation: function () {
        const animation = new cleverapps.Spine(bundles.crab_maker.jsons.crab_maker_animation_json);
        animation.setPosition(this.width / 2, this.height / 2);
        animation.setStartVisibleListener(() => {
            this.image.visible = false;
        });
        this.addChild(animation);
        this.animation = animation;
    },

    getImage: function (stage) {
        return bundles.crab_maker.frames[`crab_maker_stable_${stage}`];
    },

    changeStage: function (callback) {
        if (this.cell.stage === 0) {
            return;
        }

        if (!this.animation) {
            this.addAnimation();
        }
        this.animation.setAnimation(0, `${this.cell.stage}`, false);
        this.animation.setCompleteListener(() => {
            this.image.setSpriteFrame(this.getImage(this.cell.stage));
            this.image.visible = true;
            this.animation.visible = false;
            if (callback) {
                callback();
            }
        });

        if (bundles.crab_maker.urls.crab_fly_effect) {
            cleverapps.effects.fire("crab_maker.fly");
        }
    },

    hurtAnimation: function () {

    }
});